<template>
  <PageSection disable-sticky-margin :title="$t('global.disponibilities')">
    <div class="flex gap-2 overflow-x-auto">
      <div
        v-for="(day, index) in metadata.days"
        class="flex flex-1 flex-col space-y-1"
      >
        <h3 class="text-center text-base font-bold capitalize-first">
          {{ day }}
        </h3>
        <template
          v-if="asset.timeslots"
          v-for="timeslot in asset.timeslots?.filter(
            (item) => item.day === parseInt(index)
          )"
        >
          <div
            class="flex rounded-md bg-primary-500 py-1 pr-1 pl-2 text-sm text-white"
          >
            <div class="flex flex-1 items-center">
              {{ timeslot.start_time }} - {{ timeslot.end_time }}
              <br />
              {{
                timeslot.event_kind
                  ? metadata.event_kinds?.filter(
                      (kind) => kind.id === timeslot.event_kind
                    )[0].name
                  : ''
              }}
            </div>
            <div class="flex-shrink-0" v-if="$can('delete_content')">
              <BaseDeleteButton
                v-if="editionMode"
                small
                :tooltip="
                  $t('button.delete_f', { var: $t('global.disponibility') })
                "
                @click="deleteTimeSlot(timeslot.id)"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </PageSection>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AssetTimeSlotIndexComponent',
  props: {
    editionMode: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      asset: 'asset/getSelectedAsset',
      metadata: 'asset/getAssetMetadata'
    }),
    cEventKind() {
      let tmp = []
      this.asset.timeslots.forEach((el) => {
        tmp.push(
          this.metadata.event_kind?.filter((item) => el.includes(item.id))
        )
      })
      return tmp
    }
  },
  methods: {
    ...mapActions({
      deleteTimeslotById: 'asset/deleteTimeslotById',
      undoDeleteTimeslotById: 'asset/undoDeleteTimeslotById'
    }),
    deleteTimeSlot(id) {
      this.deleteTimeslotById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.timeslot') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteTimeslot(id)
            }
          ]
        )
      })
    },
    undoDeleteTimeslot(id) {
      this.undoDeleteTimeslotById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.timeslot') })
        )
      })
    }
  }
}
</script>
